module.exports = __webpack_public_path__ + "img/40_photo.d7316b49.png";